import React from "react";
import { Link } from "react-router-dom";
import AboutPractice from "../components/AboutPractice";

const About = () => {
  return (
    <div className="Text__Body">
      <span className="eyebrow">Our Practice</span>
      <h1>About Monument Dental</h1>
      <AboutPractice />
      <div className="about-cta">
        <h2>Ready to visit us?</h2>
        <p>
          We'd love to welcome you and your family to our practice. Get started
          as a new patient or reach out with any questions.
        </p>
        <div className="about-cta__actions">
          <Link to="/NewPatient" className="button">
            New Patients
          </Link>
          <Link to="/Contact" className="button button--inverse">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
